import {create} from "zustand";
import axios from "axios";
import {api} from "./api";

export const usePublicStore = create((set) => ({
    reference: null,
    categories: [],
    blogs: [],
    loading: false,
    error: null,
    getReference: async (token) => {
        set({loading: true, error: null});
        try {
            const {data} = await axios.get(`${api}/realty/realty-references`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });
            set({
                reference: data,
                loading: false,
            });
        } catch (e) {
            set({
                error: e,
                loading: false,
            });
            if (e.response?.status === 401) {
                localStorage.clear();
                window.location.href = "/detail/login/";
            }
        }
    },
    category: async () => {
        set({loading: true, error: null});
        try {
            const {data} = await axios.get(`${api}/public/category-list`);
            set({
                categories: data,
                loading: false,
            });
        } catch (e) {
            set({
                error: e,
                loading: false,
            });
        }
    },
    blog: async () => {
        set({loading: true, error: null});
        try {
            const {data} = await axios.get(`${api}/public/blog`);
            set({
                blogs: data,
                loading: false,
            });
        } catch (e) {
            set({
                error: e,
                loading: false,
            });
        }
    },
}));

export const useFetchReference = () =>
    usePublicStore((state) => state.getReference);
export const useReference = () =>
    usePublicStore((state) => state.reference);
export const useFetchCategory = () =>
    usePublicStore((state) => state.category);
export const useCategory = () =>
    usePublicStore((state) => state.categories);
export const useGetBlog = () =>
    usePublicStore((state) => state.blog);
export const useBlog = () =>
    usePublicStore((state) => state.blogs);
